const baseUrl = "https://app.arpm.health";

export const environment = {
  production: false,
  serviceWorker: true,
  defaultLanguage: "en-US",
  apiLocations: {
    identity: `${baseUrl}/identity/api/v1`,
    patient: `${baseUrl}/patient/api/v1`,
    patientHub: `${baseUrl}/patient-hub`,
    customer: `${baseUrl}/customer/api/v1`,
    chat: `${baseUrl}/chat/api/v1`,
    notification: `${baseUrl}/notification/api/v1`,
    organization: `${baseUrl}/organization/api/v1`,
    organizationDept: `${baseUrl}/organization/api/v1`,
    device: `${baseUrl}/device/api/v1`,
    chatApi: `${baseUrl}/chatapi/v2`,
    audit: `${baseUrl}/audit/api/v1`,
    communication: `${baseUrl}/communication/api/v1`,
    report: `${baseUrl}/report/api/v1`,
    healthIntegration: `${baseUrl}/health-integration/api/v1`,
    appointment: `${baseUrl}/appointment/api/v1`,
    appoinment: `${baseUrl}/appointment/api/v1`,
  },
  siteKey: "6LeGF9oqAAAAAIMOPseb6vT3yM_xrN70BcCxnChh",
};
